import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory } from '@fortawesome/pro-light-svg-icons';
import CircularProgress from '@material-ui/core/CircularProgress';

const colors = {
   HR: '#CE65D1',
   G: '#F383BB',
   S: '#623C21',
   B: '#EDD217',
   P: '#67B0DA',
};

const useStyles = makeStyles((theme) => ({
   currencey: {
      fontSize: '1.25rem',
      color: 'grey',
   },
   chip: {
      padding: '3px 10px',
      borderRadius: '5px',
      color: 'white',
   },
   logoHR: {
      borderRadius: '50%',
      border: 'solid blue 2.5px',
      height: 40,
      width: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '2.5rem',
      marginRight: '10px',
   },
   logo: {
      borderRadius: '50%',
      border: 'solid blue 2.5px',
      height: 100,
      width: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.0rem',
      marginRight: '10px',
      textAlign: 'center',
   },
   point: {
      fontSize: '2rem',
      color: 'black',
      fontWeight: 'bold',
   },
   container1: {
      display: 'flex',
      flexWrap: 'wrap',
   },
   container2: {
      minWidth: 250,
      width: '25%',
   },
   cardHeader: {
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1.2,
      backgroundColor: '#F6F6F6',
      borderRadius: '5px 5px 0 0',
      padding: '10px 30px',
   },
   cardFooter: {
      fontSize: '1rem',
      borderRadius: '0 0 5px 5px',
      color: 'white',
      padding: '5px 20px',
      display: 'flex',
      alignItems: 'center',
   },
   loading: {
      width: '100%',
      backgroundColor: '#F2F2F2',
      borderRadius: '5px',
      height: 40,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
   },
}));

const TotalPoint = ({ totalPoint, isLoading }) => {
   const classes = useStyles();

   const costFormat = (value) => {
      return value && new Intl.NumberFormat().format(value);
   };

   return (
      <div>
         {!isLoading ? (
            <div>
               <div style={{ marginBottom: '10px' }}>
                  {totalPoint && totalPoint.hrPoints && (
                     <div style={{ width: '100%' }}>
                        <div className={classes.cardHeader}>
                           <div
                              style={{
                                 display: 'flex',
                                 justifyContent: 'center',
                                 alignItems: 'center',
                                 width: '100%',
                              }}
                           >
                              <div
                                 className={classes.logoHR}
                                 style={{
                                    borderColor: colors['HR'],
                                    color: colors['HR'],
                                    fontSize: '1.75rem',
                                 }}
                              >
                                 HR
                              </div>
                              <div>
                                 <div style={{ display: 'flex' }}>
                                    <div
                                       className={classes.chip}
                                       style={{
                                          marginRight: '10px',
                                          backgroundColor: colors['HR'],
                                       }}
                                    >
                                       ทั้งหมด :{' '}
                                       {costFormat(
                                          totalPoint.hrPoints.totalReceived,
                                       )}
                                    </div>
                                    <div
                                       className={classes.chip}
                                       style={{
                                          marginRight: '10px',
                                          backgroundColor: colors['HR'],
                                       }}
                                    >
                                       ใช้ไป P :{' '}
                                       {costFormat(
                                          totalPoint.hrPoints
                                             .totalBankWalletUsed,
                                       )}
                                    </div>
                                    <div
                                       className={classes.chip}
                                       style={{
                                          marginRight: '10px',
                                          backgroundColor: colors['HR'],
                                       }}
                                    >
                                       ใช้ไป GSB Way of Work :{' '}
                                       {costFormat(
                                          totalPoint.hrPoints.totalEmployeeUsed,
                                       )}
                                    </div>
                                    <div
                                       className={classes.chip}
                                       style={{
                                          marginRight: '10px',
                                          backgroundColor: colors['HR'],
                                       }}
                                    >
                                       ใช้ไปหลักเกณฑ์ :{' '}
                                       {costFormat(
                                          totalPoint.hrPoints.totalRuleUsed,
                                       )}
                                    </div>
                                 </div>
                                 <div
                                    className={classes.point}
                                    style={{ fontSize: '20px' }}
                                 >
                                    คงเหลือ :{' '}
                                    {costFormat(
                                       totalPoint.hrPoints.totalRemainingPoints,
                                    )}
                                 </div>
                                 <div style={{ color: 'red' }}>
                                    ใช้ไปหลักเกณฑ์ หมายถึง
                                    จำนวนคะแนนที่หลักเกณฑ์ได้รับจาก HR
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className={classes.cardFooter}
                           style={{
                              backgroundColor: colors['HR'],
                              justifyContent: 'center',
                           }}
                        >
                           <div>
                              <FontAwesomeIcon
                                 icon={faHistory}
                                 size={'xs'}
                                 style={{ marginRight: 5 }}
                              />
                              อัพเดทคะแนนเมื่อ{' '}
                              {totalPoint.hrPoints.updateTimeLabel}
                           </div>
                        </div>
                     </div>
                  )}
               </div>
               <div className={classes.container1}>
                  {totalPoint &&
                     totalPoint.allPoints &&
                     totalPoint.allPoints
                        .sort((a, b) => {
                           const order = { P: 0, B: 1, G: 2, S: 3 };
                           return order[a.currency] - order[b.currency];
                        })
                        .map((point, index) => {
                           const currencyTextMap = {
                              G: 'with GOVERNANCE',
                              S: 'through DIGITALIZATION',
                              B: 'for SOCIETY',
                           };
                           const displayCurrency =
                              currencyTextMap[point.currency] || point.currency;

                           return (
                              <div key={index} className={classes.container2}>
                                 <div
                                    style={{
                                       paddingRight:
                                          totalPoint.allPoints.length - 1 ===
                                          index
                                             ? 0
                                             : 10,
                                    }}
                                 >
                                    <div className={classes.cardHeader}>
                                       <div
                                          className={classes.logo}
                                          style={{
                                             borderColor:
                                                colors[point.currency],
                                             color: colors[point.currency],
                                             fontSize:
                                                point.currency === 'P'
                                                   ? '1.75rem'
                                                   : undefined,
                                          }}
                                       >
                                          {displayCurrency}
                                       </div>
                                       <div>
                                          <div>คะแนนทั้งหมด/ใช้ไป</div>
                                          <div className={classes.point}>
                                             {costFormat(point.totalReceived)}/
                                             {costFormat(point.totalRedeem)}
                                          </div>
                                          <div
                                             className={classes.point}
                                             style={{ fontSize: '20px' }}
                                          >
                                             คงเหลือ :{' '}
                                             {costFormat(
                                                point.totalRemainingPoints,
                                             )}
                                          </div>
                                       </div>
                                    </div>
                                    <div
                                       className={classes.cardFooter}
                                       style={{
                                          backgroundColor:
                                             colors[point.currency],
                                       }}
                                    >
                                       <div>
                                          <FontAwesomeIcon
                                             icon={faHistory}
                                             size={'xs'}
                                             style={{ marginRight: 5 }}
                                          />
                                          อัพเดทคะแนนเมื่อ{' '}
                                          {point.updateTimeLabel}
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           );
                        })}
               </div>
            </div>
         ) : (
            <div className={classes.loading}>
               <CircularProgress size={20} />
            </div>
         )}
      </div>
   );
};

export default TotalPoint;
